import { SearchType } from '@zoopla/landing-pages/types';
import { BreadCrumbs } from '../landing-pages.types';
import { GraphQLError } from 'graphql';

export const returnBreadCrumbs = (slug: SearchType) => {
    const breadcrumbs: BreadCrumbs[] = [
        {
            id: 'zoopla',
            text: 'Zoopla',
            ariaLabel: "Zoopla's Homepage",
            href: '/',
        },
    ];

    switch (slug) {
        case 'to-rent':
            breadcrumbs.push({
                id: 'torent',
                text: 'To rent',
                ariaLabel: 'To rent',
                href: '/to-rent/',
            });

            break;

        case 'for-sale':
            breadcrumbs.push({
                id: 'forsale',
                text: 'For sale',
                ariaLabel: 'For sale',
                href: '/for-sale/',
            });
            break;

        case 'house-prices':
            breadcrumbs.push({
                id: 'houseprices',
                text: 'House prices',
                ariaLabel: 'House prices',
                href: '/house-prices/',
            });
            break;

        case 'new-homes':
            breadcrumbs.push({
                id: 'newhomes',
                text: 'New homes',
                ariaLabel: 'New homes',
                href: '/new-homes/',
            });
            break;

        case 'home-values':
            breadcrumbs.push({
                id: 'homevalues',
                text: 'Instant valuation',
                ariaLabel: 'Instant valuation',
                href: '/home-values/',
            });
            break;

        case 'remortgage':
            breadcrumbs.push({
                id: 'remortgage',
                text: 'Remortgage',
                ariaLabel: 'Remortgage',
                href: '/remortgage/',
            });
            break;
    }

    return breadcrumbs;
};

export const isCrash = (e: readonly GraphQLError[]): boolean => {
    return e.some(
        (error: GraphQLError) =>
            error.extensions['code'] === 'GRAPHQL_VALIDATION_FAILED' ||
            error.extensions['code'] === 'INTERNAL_SERVER_ERROR'
    );
};
